import React, { Component } from 'react'
import { css } from 'emotion'
import IMG1 from './../../../static/rm-charity-org.jpg'
import { fetchDonator, submitDonator } from './../../../services/ApiController'
import { Field, SelectCountries, SelectPhone, Textarea } from './../../../components'
import { Colors, Font } from '../../../styles'
import DatePicker from "react-datepicker"
import * as moment from 'moment'

const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

const Style = css({
  '.charity': {
    '&-inner': {
      padding: '2rem',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      maxWidth: 1088,
      margin: '0 auto',

      '@media (min-width: 768px)': {
        padding: '4rem',
      },
      '.btn-reload': {
        display: 'inline-block',
        background: 'black',
        width: '200px',
        color: 'white',
        border: 0,
        textTransform: 'uppercase',
        fontWeight: 800,
        fontFamily: Font.base,
        letterSpacing: '0.125rem',
        height: 60,
        transition: 'all 400ms ease',
        cursor: 'pointer',
        margin: '1rem 0px',
      },
      '.text-center': {
        textAlign: 'center'
      },
      '.btn-expand': {
        textTransform: 'uppercase',
        color: Colors.grey,
        fontSize: '0.75rem',
        letterSpacing: '2.5px',
        padding: 0,
        border: 0,
        fontFamily: Font.base,
        fontWeight: 800,
        background: 'none',
      },
    },
    '&-title': {
      color: 'black',
      fontSize: '2rem',
      textTransform: 'uppercase',
      '&:after': {
        content:"''",
        display:"block",
        width: 50,
        height: 4,
        background: 'black',
        margin: '1rem auto',
      },
    },
    '&-picture': {
      // maxWidth: 100%,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      maxHeight: 270,
      overflow: 'hidden',
      'img': {
        maxWidth: '100%',
        '@media (min-width: 768px)': {
          transform: 'translateY(-60px)',
        }
      }
    },
    '&-description': {
      color: 'black',
      fontSize: '0.9375rem',
      fontWeight: 600,
      'span': {
        color: Colors.red,
      }
    },
    '&-bottom': {
      color: 'black',
      fontSize: '0.9375rem',
      fontStyle: 'italic',
      fontWeight: 200,
      'p > a': {
        color: 'black',
      }
    },
    '&-mandatory': {
      color: Colors.red,
      fontSize: '0.9375rem',
    },
    '&-container': {
      maxWidth: '100%',
      '@media (min-width: 768px)': {
        padding: '0 3.6rem',
      },
    },
    '&-form': {
      'input[type="text"], input[type="text"] + label': {
        fontSize: '1.5rem'
      },
      '.dropdown-list': {
        zIndex: 2,
      },
      '.required-phone': {
        display: 'flex',
        alignItems: 'flex-end',
        '.form-field': {
          maxWidth: 'calc(100% - 110px)',
          flexBasis: 'calc(100% - 110px)',
          width: '100%',
          marginLeft: 10,
        }
      },
      '.required-id': {
        width: 100
      },
      '.required-location': {
        width: 440
      },
      '.required-comment ': {
        'label': {
          fontWeight: 400,
          zIndex: -1,
        },
        'textarea': {
          height: 60,
          fontSize: '0.875rem',
          fontWeight: 600,
          marginTop: 16,
        }
      },
      'sup': {
        color: Colors.red,
      },
      '&-row': {
        margin: '1.5rem 0 3.5rem',
      },
      '.row': {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      },
      '&-label' :{
        textTransform: 'uppercase',
        // marginBottom: '1rem',
        fontWeight: 800,
        fontFamily: Font.base,
        fontSize: '1rem',
        color: Colors.grey,
      },
      '&-full': {
        width: '100%',
      },
      '&-col' :{
        width: '100%',
        '@media (min-width: 768px)': {
          width: 'calc(50% - 1rem)',
          maxWidth: 'calc(50% - 1rem)',
          flexBasis: 'calc(50% - 1rem)',
        }
      },
      '&-radio': {
        display: 'flex',
        alignItems: 'center',
      },
      '.dropdown-label': {
        textAlign: 'left',
        fontSize: 22,
      },
      '.react-datepicker-wrapper, .react-datepicker-popper, .react-datepicker__input-container': {
        zIndex: 2,
        width: '100%',
      },
      '.date input[type="text"]': {
        fontSize: 22,
        color: Colors.dark,
        fontFamily: Font.base,
        width: '100%',
        zIndex: 2,
        width: '100%',
        margin: '0.3125rem 0px',
        padding: '0.3125rem 0',
        background: 'none',
        border: 0,
        borderBottom: `1px solid ${Colors.lightGrey}`,
        WebkitAppearance: 'none',
        '@media (min-width: 1024px)': {
          padding: '0.625rem 0px',
        },
        '&::placeholder': {
          color: Colors.lightGrey,
        }
      },
      '&-bottom': {
        display:"flex",
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        '.btn': {
          background: Colors.red,
          width: 260,
          border: 0,
          fontSize: '0.825rem',
          lineHeight: '1.2em',
          textTransform: 'uppercase',
          fontFamily: Font.base,
          fontWeight: 800,
          letterSpacing: '0.125rem',
          height: 60,
          transition: 'all 400ms ease',
          cursor: 'pointer',
          margin: '1rem 0px',
          color: 'white',
        }
      },
      '.is-error': {
        'input, label > span:before, .dropdown-label': {
          borderColor: `${Colors.red} !important`,
        },
        'label, input::placeholder, label > span, .dropdown-label': {
          color: `${Colors.red} !important`
        }
      },
    },
    '&-radio': {
      marginRight: '1rem',
      
      'input': {
        position: 'absolute',
        width: '1px',
        height: '1px',
        padding: '0',
        margin: '-1px',
        overflow: 'hidden',
        clip: 'rect(0, 0, 0, 0)',
        border: 0,
        '&:checked + span': {
          '&:after': {
            opacity: 1,
          }
        }
      },
      'label': {
        'span': {
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          color: Colors.grey,
          fontSize: 22,
          '&:before': {
            display: 'block',
            width: 12,
            height: 12,
            borderRadius: '50%',
            marginRight: 8,
            border: `1px solid ${Colors.grey}`,
            content:"''",
          },
          '&:after': {
            position:'absolute',
            width: 8,
            height: 8,
            top: '50%',
            left: 3,
            background: 'black',
            borderRadius: '50%',
            content:"''",
            transform: 'translateY(-50%)',
            opacity: 0,
          }
        }
      },

      '&--check': {
        'label': {
          'span': {
            fontSize: '0.9375rem',
            color: 'black',
            fontWeight: 600,

            'i' :{
              display: 'inline-block',
              marginLeft: '10px',
              maxWidth: 'calc(100% - 50px)',
            },

            '&:before, &:after': {
              borderRadius: 0,
            },
          }
        },
      },
    },
    '&-error': {
      fontSize: 14,
      color: Colors.red,
    },
    '&-btn': {
      position: 'relative',
      textAlign: 'right',
    },
    '&-success': {
      color: '#0C7B2A',
      fontSize: 18,
      textAlign: 'center',
      fontWeight: 800,
      textTransform: 'uppercase',
    },
  },
})
export default class CharityForm extends Component {

  state = {
    formData: {
      comments: '',
      gender: '',
      email: '',
      location: '',
      meetingDate: '',
      name: '',
      phone: '',
      postalAddress: '',
      preferredLanguage: '',
      referer: '',
      surname: '',
      country: '',
      title: '',
      token: '',
      refererGender: '',
      refererName: '',
      refererSurname: '',
      contactId: '',
      postalCode: '',
      city: '',
      phonePrefix: '',
      token: ''
    },
    form: {},
    wait: true,
    error: '',
    isSend: false,
    isExpand: false,
    consent: ''
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    // /donator/form/submit.json
    const res = await fetchDonator()
    if (res) {
      this.setState({
        formData: {
          ...this.state.formData,
          token: res.donator.token.value,
        },
        form: {
          ...res.donator,
        },
        wait: false
      })
    }
  }

  handlerSubmit (e) {
    e.preventDefault()
    const { title, surname, name, phone, email, referer, meetingDate, location, contactId, refererName, refererSurname, country, refererGender, gender, phonePrefix } = this.state.formData
    this.setState({
      error: '',
    })

    if (surname === '' || name === '' || phone === '' || email === '' || country === '' || referer === '' || meetingDate === '' || location === '' || this.state.consent === '' || contactId === '' || refererName === '' || refererSurname === '' || refererGender === '' || gender === '' || phonePrefix === '' || title === '') {
      this.setState({
        error: 'Contact ID, Referer, Client meeting date, Referer name, Referer Surname(s), email, phone number and consent are required !',
      })

      this.isRequired(document.querySelector('.required-meeting'), 'meetingDate')
      this.isRequired(document.querySelector('.required-referer'), 'referer')
      this.isRequired(document.querySelector('.required-title'), 'title')
      this.isRequired(document.querySelector('.required-refererGender'), 'refererGender')
      this.isRequired(document.querySelector('.required-country'), 'country')
      this.isRequired(document.querySelector('.required-surname'), 'surname')
      this.isRequired(document.querySelector('.required-refererSurname'), 'refererSurname')
      this.isRequired(document.querySelector('.required-name'), 'name')
      this.isRequired(document.querySelector('.required-refererName'), 'refererName')
      this.isRequired(document.querySelector('.required-phone'), 'phone')
      this.isRequired(document.querySelector('.required-phone'), 'phonePrefix')
      this.isRequired(document.querySelector('.required-email'), 'email')
      this.isRequired(document.querySelector('.required-location'), 'location')
      this.isRequired(document.querySelector('.required-consent'), 'consent')
      this.isRequired(document.querySelector('.required-id'), 'contactId')
      this.isRequired(document.querySelector('.required-gender'), 'gender')

    } else if (!pattern.test(email)) {
      document.querySelector('.required-email').classList.add('is-error')
      this.setState({
        error: ' Email address is not valid',
      })
    } else {
      document.querySelector('.required-email').classList.remove('is-error')
      document.querySelector('.required-meeting').classList.remove('is-error')
      document.querySelector('.required-referer').classList.remove('is-error')
      document.querySelector('.required-country').classList.remove('is-error')
      document.querySelector('.required-surname').classList.remove('is-error')
      document.querySelector('.required-refererSurname').classList.remove('is-error')
      document.querySelector('.required-refererGender').classList.remove('is-error')
      document.querySelector('.required-name').classList.remove('is-error')
      document.querySelector('.required-refererName').classList.remove('is-error')
      document.querySelector('.required-phone').classList.remove('is-error')
      document.querySelector('.required-location').classList.remove('is-error')
      document.querySelector('.required-consent').classList.remove('is-error')
      document.querySelector('.required-id').classList.remove('is-error')
      document.querySelector('.required-title').classList.remove('is-error')
      document.querySelector('.required-gender').classList.remove('is-error')

      submitDonator({donator: this.state.formData}).then((res) => {
        if (res.success) {
          this.setState({
            isSend: true,
          })
        }
      })
    }
  }

  isRequired(row, key) {
    row.classList.remove('is-error')
    if (this.state.formData[key] === '') {
      row.classList.add('is-error')
    }
  }

  reload () {
    document.location.reload();
  }

  handleClickExpand () {
    this.setState({
      isExpand: !this.state.isExpand
    })
  }

  render() {
    return (
      <div className={`charity ${Style}`}>
        <div className="charity-inner">
          <h1 className="charity-title">DONATOR CONTACT FORM</h1>
          <div className="charity-picture">
            <img src={IMG1} alt=""/>
          </div>
          {!this.state.wait && (
            <div className="charity-container">
              { !this.state.isSend && (
                <form className="charity-form" onSubmit={(e) => this.handlerSubmit(e)}>
                  <p className="charity-description">Enter the following information and keep paper registration form for record (GDPR legislation). Client will be contacted by Paris Brain Institute team. <span>Important: All fields must be filled in english.</span></p>
                  <div className="charity-form-row">
                    <div className="charity-form-label">Referer <sup>*</sup></div>
                    <div className="row">
                      <div className="charity-form-third charity-form-radio required-referer">
                        <div className="charity-radio">
                          <label htmlFor="chartiy[referer][boutique]">
                            <input type="radio" id="chartiy[referer][boutique]" name="chartiy[referer]" value="boutique" onChange={(e) => { this.setState({ formData: { ...this.state.formData, referer: e.target.value } }) }} />
                            <span>Boutique</span>
                          </label>
                        </div>
                        <div className="charity-radio">
                          <label htmlFor="chartiy[referer][office]">
                            <input type="radio" id="chartiy[referer][office]" name="chartiy[referer]" value="office" onChange={(e) => { this.setState({ formData: { ...this.state.formData, referer: e.target.value } }) }} />
                            <span>Office</span>
                          </label>
                        </div>
                      </div>
                      <div className="charity-form-third required-id">
                        <Field type="text" name="chartiy[referer][ID]" onChange={(data) => this.setState({ formData: { ...this.state.formData, contactId: data.value } })}> ID<sup>*</sup> </Field>
                      </div>
                      <div className="charity-form-third required-location">
                        <Field type="text" name="chartiy[referer][location]" onChange={(data) => this.setState({ formData: { ...this.state.formData, location: data.value } })}>City and Country (e: Paris France)<sup>*</sup></Field>
                      </div>
                    </div>
                    <div className="row">
                      <div className="charity-form-col charity-form-radio required-refererGender">
                        <div className="charity-radio">
                          <label htmlFor="charity[referer][gender][mr]">
                            <input type="radio" id="charity[referer][gender][mr]" name="charity[referer][gender]" value="Mr" onChange={(e) => { this.setState({ formData: { ...this.state.formData, refererGender: e.target.value } }) }} />
                            <span>Mr <sup>*</sup></span>
                          </label>
                        </div>
                        <div className="charity-radio">
                          <label htmlFor="charity[referer][gender][ms]">
                            <input type="radio" id="charity[referer][gender][ms]" name="charity[referer][gender]" value="Ms" onChange={(e) => { this.setState({ formData: { ...this.state.formData, refererGender: e.target.value } }) }} />
                            <span>Ms <sup>*</sup></span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="charity-form-col required-refererSurname">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, refererName: data.value } })}>First name <sup>*</sup> </Field>
                      </div>
                      <div className="charity-form-col required-refererName">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, refererSurname: data.value } })} >Surname (s) <sup>*</sup> </Field>
                      </div>
                    </div>
                  </div>
                  <div className="charity-form-row">
                    <div className="charity-form-label">Client meeting date <sup>*</sup></div>
                    <div className="row">
                      <div className="charity-form-col date required-meeting">
                        <DatePicker
                          selected={this.state.date}
                          onChange={(date) => this.setState({ formData: { ...this.state.formData, meetingDate: moment(date).format('DD/MM/YYYY') }, date })}
                          placeholderText="DD/MM/YYYY"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="charity-form-row">
                    <div className="charity-form-label">Contact detail</div>
                    <div className="row">
                      <div className="charity-form-col charity-form-radio required-gender">
                        <div className="charity-radio">
                          <label htmlFor="charity[gender][mr]">
                            <input type="radio" id="charity[gender][mr]" name="charity[gender]" value="Mr" onChange={(e) => { this.setState({ formData: { ...this.state.formData, gender: e.target.value } }) }} />
                            <span>Mr <sup>*</sup></span>
                          </label>
                        </div>
                        <div className="charity-radio">
                          <label htmlFor="charity[gender][ms]">
                            <input type="radio" id="charity[gender][ms]" name="charity[gender]" value="Ms" onChange={(e) => { this.setState({ formData: { ...this.state.formData, gender: e.target.value } }) }} />
                            <span>Ms <sup>*</sup></span>
                          </label>
                        </div>
                        <div className="charity-radio">
                          <label htmlFor="charity[gender][mr-ms]">
                            <input type="radio" id="charity[gender][mr-ms]" name="charity[gender]" value="Mr-ms" onChange={(e) => { this.setState({ formData: { ...this.state.formData, gender: e.target.value } }) }} />
                            <span>Mr & Ms <sup>*</sup></span>
                          </label>
                        </div>
                      </div>
                      <div className="charity-form-col required-title">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, title: data.value } })}>Title <sup>*</sup></Field>
                      </div>
                      <div className="charity-form-col required-name">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, name: data.value } })} >First Name <sup>*</sup> </Field>
                      </div>
                      <div className="charity-form-col required-surname">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, surname: data.value } })} >Surname(s) <sup>*</sup> </Field>
                      </div>
                      <div className="charity-form-col">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, postalAddress: data.value } })} >Postal address </Field>
                      </div>
                      <div className="charity-form-col">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, postalCode: data.value } })} >Postal code </Field>
                      </div>
                      <div className="charity-form-col">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, city: data.value } })} >City </Field>
                      </div>
                      <div className="charity-form-col required-country">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, country: data.value } })} >Country <sup>*</sup></Field>
                      </div>
                      
                      <div className="charity-form-col required-email">
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, email: data.value } })} >Email <sup>*</sup> </Field>
                      </div>
                      <div className="charity-form-col required-phone">
                        {/* LANG */}
                        <SelectPhone label="" callback={(data) => this.setState({ formData: { ...this.state.formData, phonePrefix: data } })} >--<sup>*</sup></SelectPhone>
                        <Field type="text" onChange={(data) => this.setState({ formData: { ...this.state.formData, phone: data.value } })} >Phone number <sup>*</sup> </Field>
                      </div>
                      <div className="charity-form-col">
                        <SelectCountries label="Prefered language" callback={(data) => this.setState({ formData: { ...this.state.formData, preferredLanguage: data} })} />
                        <p>If we are not able to honor the preferred language, the client will automatically be contacted in English.</p>
                      </div>
                      <div className="charity-form-full required-comment">
                        <Textarea  onChange={(data) => this.setState({ formData: { ...this.state.formData, comments: data.value } })} >Comments </Textarea>
                      </div>
                    </div>
                    <div className="charity-form-row">
                      <div className="charity-form-full required-consent">
                        <div className="charity-radio charity-radio--check">
                          <label htmlFor="charity[consent]">
                            <input type="checkbox" id="charity[consent]" name="charity[consent]" value="1" onChange={(e) => { this.setState({ consent: e.target.value }) }} />
                            <span>
                              <i>In the context of the amended French Data Protection Act and European regulations, by ticking this box, you declare that you have actually received the informed consent of the customer on the processing of his personal data and are able to provide proof of this consent. <sup>*</sup></i>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  { !this.state.isExpand ? 
                    <p className="charity-bottom">The information collected on this form is collected and recorded in a computerised file by the sales staff of the Richard MILLE stores on behalf of the company RDMM CONCEPTS, data controller, whose head office is located 1 rue de la Manutention – 75116 Paris – France. Represented by Mr Richard MILLE. <br />The legal basis of the treatment is the client’s consent.</p>
                  :
                  <p className="charity-bottom--expand">
                    The information collected on this form is collected and recorded in a computerised file by the sales staff of the Richard MILLE stores on behalf of the company RDMM CONCEPTS, data controller, whose head office is located 1 rue de la Manutention – 75116 Paris – France. Represented by Mr Richard MILLE.<br/>
                    The legal basis of the treatment is the client’s consent.<br/>
                    The purpose of the treatment is to build up a file of Richard MILLE clients who are concerned about the cause of the Paris Brain Institute (“ICM”) and who wish to become members of the Richard Mille Donors’ Club. The data collected is shared with the ICM.<br/>
                    The data collected will be communicated to the following recipients only: Richard Mille staff and partners; ICM staff in charge of fundraising.<br/>
                    The data will be kept for 3 years from the last contact or until the consent’s withdraw.<br/>
                    In accordance with the amended French Data Protection Act and European regulations, you may withdraw your consent at any time. You have a right of access to your data, a right of rectification, a right to limit processing, a right of opposition, portability and deletion. In addition, you can define guidelines on the fate of your data after your death. You can exercise your rights by contacting RDMM Concepts [1 rue de la Manutention, 75116 Paris, France] or the Data Protection Officer by e-mail <a href="mailto:privacy@richardmille.com" target="_blank">privacy@richardmille.com</a>. You also have the right to lodge a complaint with a supervisory authority, the CNIL in France.
                  </p>
                  }
                  <button type="button" className="btn btn-expand" onClick={() => this.handleClickExpand()}>
                    { !this.state.isExpand ? 
                      <span>View more</span> :
                      <span>View less</span>
                    }
                  </button>
                  <div className="charity-form-bottom">
                    <p className="charity-mandatory">*mandatory</p>
                    <div className="charity-btn">
                      <button type="submit" className="btn btn-submit">Send</button>
                      {this.state.error !== '' && <p className="charity-error">{this.state.error}</p>}
                    </div>
                  </div>
                </form>
              )}
              {
                this.state.isSend && (
                  <div class="text-center">
                    <p className="charity-success">Registration confirmed. <br/>Your client will be contacted shortly by Paris Brain institute team.</p>
                    <button type="button" className="btn btn-reload" onClick={() => this.reload()}>New Registration</button>
                  </div>
                )
              }
            </div>
          )}
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/scenes/Pages/container/CharityForm.js